import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { modalFooterStyles } from './styles/modal-footer.styles';
import type { ModalFooterPropsInterface } from './types/modal-footer.types';

/**
 * @since 10.0.0
 */
export const ModalFooter = forwardRef<HTMLDivElement, ModalFooterPropsInterface>(
  (props: ModalFooterPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(modalFooterStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Modal.Footer"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

ModalFooter.displayName = 'Modal.Footer';
